import React from 'react'
import { buttonStyle, titleStyle, barStyle } from './styles.js'
import './titleBar.css'

export default function TitleBar(props){
  let {
    title,
    leftButtonLabel,
    leftButtonAction,
    rightButtonLabel,
    rightButtonAction,
    emailNoteButtonLabel,
    emailNoteButtonAction
  } = props
  leftButtonAction = leftButtonAction ? leftButtonAction : () => {}
  rightButtonAction = rightButtonAction ? rightButtonAction : () => {}
  emailNoteButtonAction = emailNoteButtonAction ? emailNoteButtonAction : () => {}
  const titleClasses = leftButtonLabel ? 'col-6' : 'col-6 offset-3'

  return(
    <div
      className='row'
      style={ barStyle } >
      { leftButtonLabel &&
        <div className='col-3' style={{ textAlign: 'left' }}>
        	<button
        		style={ buttonStyle }
        		dangerouslySetInnerHTML={{ __html: leftButtonLabel}}
        		onClick={ leftButtonAction }>
        	</button>
        </div>
      }
      <div
        style={ titleStyle }
        className={ titleClasses }>
        <h6 className='page-title'>{ title }</h6>
      </div>
      { rightButtonLabel &&
        <div className='col-3' style={{ textAlign: 'right' }}>
        	<button
        		style={ buttonStyle }
        		dangerouslySetInnerHTML={{ __html: rightButtonLabel}}
        		onClick={ rightButtonAction }>
        	</button>
        	{ emailNoteButtonLabel &&
            <a
            	href={emailNoteButtonAction}
            	style={ buttonStyle }
            	dangerouslySetInnerHTML={{ __html: emailNoteButtonLabel}}>
            </a>

        	}
        </div>
      }
    </div>
  )
}
